import { render } from "./BaseHeader.vue?vue&type=template&id=03247aa2"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tito\\Documents\\Proyectos\\Dada\\dashboard-agente\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__